import { Controller } from "@hotwired/stimulus"
import { showBootstrapConfirm } from "../turbo_confirm"

// Confirmation dialog for forms that opt out of Turbo
// (data-turbo="false"). Turbo's built-in turbo_confirm only fires on
// Turbo-driven submissions, so non-Turbo forms (e.g. the one-time
// credential reveals, which Turbo cannot render) wire this controller
// to get the same Bootstrap confirm modal before a native submit.
export default class extends Controller {
  static values = { message: String }

  confirm(event) {
    if (this.confirmed) return

    event.preventDefault()
    showBootstrapConfirm(this.messageValue)
      .catch(() => window.confirm(this.messageValue))
      .then((confirmed) => {
        if (!confirmed) return
        this.confirmed = true
        this.element.requestSubmit()
      })
  }
}
